import ProgressBar from "@/components/ProgressBar";
import { BaseURLLocation } from "@/models/Utility";
import { fetchTenantListRequest, fetchUserProfile } from "@/redux/actions";
import { getCountryBaseNameFromUrl } from "@/utils/Common";
import Avatar from "@material-ui/core/Avatar";
import { ExitToAppSharp } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Drawer, FormControlLabel, Grid, List, Radio, RadioGroup, Select, TextField, Typography, useMediaQuery, } from "@mui/material";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import _ from "lodash";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../pages/OnBoarding/Login/LoginService";
import ListItems from "./ListItem";
import "./assets/layout.scss";
const drawerWidth = 280;
import { config, isProject } from "../../config";
import { Constants } from "@/utils/Constants";
const getHeaderLogo = () => {
    if (isProject("zippyy")) {
        return require("../../assets/Onboarding/Zippyy-icon.png").default;
    }
    else if (isProject("bigship")) {
        return require("../../assets/Onboarding/Bigship_Icon.png").default;
    }
    else if (isProject("shipnexa")) {
        return require("../../assets/Onboarding/shipnexa_Icon.png").default;
    }
    else if (isProject("stcourier")) {
        return require("../../assets/Onboarding/Stcourier_Icon.svg").default;
    }
    return require("../../assets/Onboarding/Zippyy-icon.png").default;
};
const Header = ({ setIsAuthenticated }) => {
    var _a, _b, _c;
    const navigate = useNavigate();
    const location = useLocation();
    const isTenantSelectHidden = location.pathname === "/remittance-approvals" ||
        location.pathname === "/rate-management/default-carrier-config";
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [onboardingPercentage, setOnboardingPercentage] = React.useState(0);
    const [initials, setInitials] = React.useState("");
    const [showBanner, setShowBanner] = React.useState(false);
    const localShowBannerData = localStorage.getItem("showBanner");
    const [tenantList, setTenantList] = React.useState([]);
    const [selectedTenantId, setSelectedTenantId] = React.useState("");
    const getTenantListState = useSelector((state) => state.getTenantListReducer);
    const dispatch = useDispatch();
    const [navListItems, setNavListItems] = React.useState([
        {
            rootItem: {
                name: "Home",
                icon: "home",
                path: "/home",
                active: false,
            },
        },
    ]);
    const userProfileState = useSelector((state) => state.User);
    const first = (_a = userProfileState.data) === null || _a === void 0 ? void 0 : _a.firstName;
    const last = (_b = userProfileState.data) === null || _b === void 0 ? void 0 : _b.lastName;
    const email = (_c = userProfileState.data) === null || _c === void 0 ? void 0 : _c.emailAddress;
    function getInitialsFromEmail(first, last) {
        if (first) {
            let firstLetter = first[0];
            let secondLetter = last[0];
            return `${firstLetter}${secondLetter}`;
        }
        else
            return "";
    }
    React.useEffect(() => {
        const calculatedInitials = getInitialsFromEmail(first, last);
        setInitials(calculatedInitials);
    }, [first]);
    const locationChange = (value) => {
        const baseUrls = {
            [BaseURLLocation.in]: Constants.REACT_APP_BASE_URL_IN,
            [BaseURLLocation.us]: Constants.REACT_APP_BASE_URL_US,
            [BaseURLLocation.za]: Constants.REACT_APP_BASE_URL_ZA,
        };
        const url = baseUrls[value];
        if (url) {
            window.open(url, "_blank");
        }
    };
    React.useEffect(() => {
        if (userProfileState.data && !_.isEmpty(userProfileState.data) && _.has(userProfileState.data, "onbrdDone")) {
            if (_.has(userProfileState.data, "state")) {
                const state = userProfileState.data.state;
                let percentage = 25;
                if (state && state.profile) {
                    percentage += 25;
                }
                if (state && state.warehouse) {
                    percentage += 25;
                }
                if (state && state.externalIntegration) {
                    percentage += 25;
                }
                if (percentage !== 100) {
                    setShowBanner(true);
                }
                else {
                    setShowBanner(false);
                }
                setOnboardingPercentage(percentage);
            }
        }
    }, [userProfileState]);
    React.useEffect(() => {
        if (selectedTenantId) {
            localStorage.setItem("tenantId", selectedTenantId);
            window.dispatchEvent(new Event("tenantIdChanged"));
        }
    }, [selectedTenantId]);
    React.useEffect(() => {
        var _a;
        if ((getTenantListState === null || getTenantListState === void 0 ? void 0 : getTenantListState.data) && !_.isEmpty(getTenantListState === null || getTenantListState === void 0 ? void 0 : getTenantListState.data)) {
            const tenants = [...getTenantListState.data];
            const sortedTenantList = tenants && (tenants === null || tenants === void 0 ? void 0 : tenants.length) > 1 ? tenants === null || tenants === void 0 ? void 0 : tenants.sort((a, b) => a.name.localeCompare(b.name)) : tenants;
            setTenantList(sortedTenantList);
            const tenantId = localStorage.getItem("tenantId") || "";
            if (!tenantId && (sortedTenantList === null || sortedTenantList === void 0 ? void 0 : sortedTenantList.length) > 0) {
                setSelectedTenantId((_a = sortedTenantList[0]) === null || _a === void 0 ? void 0 : _a.tenantId);
            }
        }
    }, [getTenantListState]);
    React.useEffect(() => {
        const tenantId = localStorage.getItem("tenantId") || "";
        if (tenantId) {
            setSelectedTenantId(tenantId);
        }
    }, []);
    React.useEffect(() => {
        dispatch(fetchUserProfile());
        if (!(getTenantListState === null || getTenantListState === void 0 ? void 0 : getTenantListState.data)) {
            dispatch(fetchTenantListRequest({ country: "India" }));
        }
        localStorage.setItem("baseLocation", getCountryBaseNameFromUrl());
    }, []);
    const handleProfileClick = () => {
        window.location.pathname = "/onboard/setup";
        setAnchorElUser(null);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleLogout = () => {
        logout();
        setIsAuthenticated(false);
        handleCloseUserMenu();
        window.location.href = "/login";
    };
    const handleCompleteOnboardingClick = () => {
        navigate("/onboard/setup");
        window.dispatchEvent(new Event("storageAccessTokenChange"));
    };
    const handleGotItClick = () => {
        setShowBanner(false);
        localStorage.setItem("showBanner", "false");
    };
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };
    const setActive = (value, item) => {
        const navListItemsTemp = [...navListItems];
        navListItemsTemp.forEach((navItem) => {
            navItem.rootItem.active = false;
            if (navItem.subItems) {
                navItem.subItems = navItem.subItems.map((subItem) => (Object.assign(Object.assign({}, subItem), { active: false })));
            }
        });
        navListItemsTemp.forEach((root) => {
            var _a;
            if (root.rootItem.name === value.rootItem.name) {
                root.rootItem.active = true;
                if (((_a = root.subItems) === null || _a === void 0 ? void 0 : _a.length) && item) {
                    root.subItems.forEach((element) => {
                        if (element.name === item.name) {
                            element.active = true;
                        }
                    });
                }
            }
        });
        setNavListItems(navListItemsTemp);
    };
    const [searchTerm, setSearchTerm] = React.useState("");
    const [searchBy, setSearchBy] = React.useState("tenantId");
    const filteredTenants = tenantList === null || tenantList === void 0 ? void 0 : tenantList.filter((menu) => {
        const fieldToSearch = searchBy === "tenantId" ? menu.tenantId : menu.name;
        return fieldToSearch === null || fieldToSearch === void 0 ? void 0 : fieldToSearch.toLowerCase().includes(searchTerm.toLowerCase());
    });
    // Get theme colors from config
    const primaryColor = config.theme.primaryColor;
    const secondaryColor = config.theme.secondaryColor;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, direction: "column", alignItems: "center", gap: 2 },
            React.createElement(Grid, { container: true, direction: "row", style: {
                    height: "64px",
                    position: "sticky",
                    top: "0",
                    zIndex: 1000,
                    background: primaryColor,
                }, justifyContent: "space-between", alignItems: "center" },
                isMobile && (React.createElement(Grid, { item: true, xs: 2, container: true, alignItems: "center" },
                    React.createElement("img", { src: getHeaderLogo(), alt: "Login", style: { width: 35, marginLeft: 5 }, onClick: toggleDrawer }))),
                React.createElement(Grid, { item: true, xs: 9, sm: 12, lg: 12, mr: 2, container: true, alignItems: "center", justifyContent: "space-between" },
                    React.createElement(Grid, { item: true, xs: 6, paddingLeft: 1, sx: { visibility: isTenantSelectHidden ? "hidden" : undefined } },
                        React.createElement(Select, { value: selectedTenantId, size: "small", onChange: (event) => {
                                setSelectedTenantId(event.target.value);
                            }, onKeyDown: (e) => {
                                if (e.key.length === 1 || ["ArrowUp", "ArrowDown"].includes(e.key)) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }, sx: {
                                boxShadow: "none",
                                width: "80%",
                                border: "1px solid white",
                                color: "white",
                                "& .MuiSvgIcon-root": {
                                    color: "white",
                                },
                            }, displayEmpty: true, MenuProps: {
                                autoFocus: false,
                                disableAutoFocusItem: true,
                            }, renderValue: (selected) => {
                                if (!selected)
                                    return "Select a tenant";
                                const selectedItem = tenantList.find((t) => t.tenantId === selected);
                                return selectedItem ? `${selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name} - ${selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.tenantId}` : "-";
                            } },
                            React.createElement(MenuItem, { disableRipple: true, disableTouchRipple: true },
                                React.createElement(Grid, { container: true, spacing: 1 },
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(TextField, { autoFocus: true, size: "small", fullWidth: true, placeholder: `Search by ${searchBy}`, value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), onMouseDown: (e) => e.stopPropagation(), onClick: (e) => e.stopPropagation(), onKeyDown: (e) => e.stopPropagation() })),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(RadioGroup, { row: true, value: searchBy, onChange: (e) => setSearchBy(e.target.value), onClick: (e) => e.stopPropagation() },
                                            React.createElement(FormControlLabel, { value: "tenantId", control: React.createElement(Radio, { size: "small" }), label: "Tenant ID" }),
                                            React.createElement(FormControlLabel, { value: "name", control: React.createElement(Radio, { size: "small" }), label: "Company Name" }))))),
                            filteredTenants.map((menu) => (React.createElement(MenuItem, { key: menu.tenantId, value: menu.tenantId },
                                menu.name,
                                " - ",
                                menu.tenantId))))),
                    React.createElement(Grid, { container: true, item: true, justifyContent: "flex-end", xs: 6 },
                        React.createElement(IconButton, { edge: "end", "aria-label": "account of current user", "aria-haspopup": "true", onClick: handleOpenUserMenu },
                            React.createElement(Avatar, { style: {
                                    width: "21px",
                                    height: "21px",
                                    fontSize: "11px",
                                    backgroundColor: "#ffffff",
                                    color: primaryColor,
                                } }, initials.toLocaleUpperCase()))),
                    React.createElement(Menu, { id: "menuId", anchorEl: anchorElUser, anchorOrigin: {
                            vertical: "top",
                            horizontal: "right",
                        }, keepMounted: true, transformOrigin: {
                            vertical: "top",
                            horizontal: "right",
                        }, open: Boolean(anchorElUser), onClose: handleCloseUserMenu },
                        React.createElement(MenuItem, { sx: { "&:hover": { backgroundColor: "transparent" } } },
                            React.createElement(Grid, { item: true },
                                React.createElement(IconButton, { "aria-label": "account of current user", "aria-haspopup": "true", sx: { marginRight: 1 } },
                                    React.createElement(Avatar, { style: {
                                            width: "23px",
                                            height: "23px",
                                            fontSize: "11px",
                                            backgroundColor: primaryColor,
                                            color: "#ffffff",
                                        } }, initials.toLocaleUpperCase()))),
                            React.createElement(Grid, { item: true, container: true, direction: "column", alignItems: "flex-start" },
                                React.createElement(Typography, { textAlign: "center", variant: "body2" }, first + " " + last),
                                React.createElement(Typography, { textAlign: "center", variant: "caption", sx: { color: "#888" } }, email))),
                        userProfileState &&
                            userProfileState.data &&
                            userProfileState.data.state &&
                            (!userProfileState.data.state.profile ||
                                !userProfileState.data.state.warehouse ||
                                !userProfileState.data.state.externalIntegration) && (React.createElement(MenuItem, { onClick: handleProfileClick, style: { marginLeft: "42px" } },
                            React.createElement(Grid, { container: true, direction: "column", justifyContent: "space-between", style: { height: "60px", width: "260px" } },
                                React.createElement(Grid, { item: true, container: true, direction: "row", justifyContent: "space-between" },
                                    React.createElement(Typography, { variant: "subtitle1", className: "m_font_size_12 m_font_color" }, "Complete your profile"),
                                    React.createElement(Typography, { variant: "subtitle1", className: "m_font_size_12 m_font_color" },
                                        onboardingPercentage / 25,
                                        "/4")),
                                React.createElement(Grid, { item: true },
                                    React.createElement(ProgressBar, { percentageCompleted: onboardingPercentage })),
                                React.createElement(Grid, { item: true },
                                    React.createElement(Typography, { variant: "subtitle1", className: "m_font_size_12 m_font_color" },
                                        onboardingPercentage,
                                        "% Complete"))))),
                        React.createElement(Divider, { flexItem: true, className: "nv_border_color" }),
                        React.createElement(MenuItem, { onClick: handleLogout },
                            React.createElement(IconButton, { "aria-label": "sign out", "aria-haspopup": "true" },
                                React.createElement(ExitToAppSharp, null)),
                            React.createElement(Typography, { textAlign: "center" }, "Sign out"))))),
            showBanner && localShowBannerData === "true" ? (React.createElement(Grid, { item: true, container: true, direction: "row", alignItems: "center", sx: { borderRadius: "10px", backgroundColor: "#FBEAE7", pl: 3, pr: 3, pt: 2, pb: 2, width: "95%" } },
                React.createElement(Grid, { item: true, xs: 9, textAlign: "center" },
                    React.createElement(Typography, { variant: "subtitle1" }, "Your onboarding is pending ! To purchase a shipment or add money to the wallet, onboarding needs to be completed.")),
                React.createElement(Grid, { item: true, xs: 3, container: true, direction: "row", justifyContent: "flex-end", gap: 2 },
                    React.createElement(Button, { variant: "contained", sx: {
                            textTransform: "none",
                            backgroundColor: primaryColor,
                            "&:hover": {
                                backgroundColor: secondaryColor,
                            },
                        }, onClick: handleCompleteOnboardingClick }, "Complete onboarding"),
                    React.createElement(Button, { variant: "contained", sx: { textTransform: "none" }, onClick: handleGotItClick }, "Got it")))) : (React.createElement(React.Fragment, null))),
        React.createElement(Drawer, { variant: "temporary", open: open, onClose: toggleDrawer },
            React.createElement("div", { className: "DrawerHeader m_bg", style: { background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}CC 100%)` } },
                React.createElement(Grid, { container: true, alignItems: "center", justifyContent: "space-between", direction: "row", style: { height: "60px" } },
                    React.createElement(Grid, { item: true, ml: 1 },
                        React.createElement("img", { src: getHeaderLogo(), alt: "Login", style: { width: 35, marginLeft: 5 }, onClick: toggleDrawer })),
                    React.createElement(Grid, { item: true },
                        React.createElement(IconButton, { onClick: toggleDrawer, style: { color: "white", fontSize: "1.5rem" } },
                            React.createElement(CloseIcon, { style: { fontSize: "2rem" } }))))),
            React.createElement(Divider, { flexItem: true, className: "nv_border_color" }),
            React.createElement(Grid, { m: 1, className: "nv_color nv_margin" },
                React.createElement(Box, null,
                    React.createElement(List, { sx: { width: "100%", maxWidth: drawerWidth, bgcolor: "background.paper" }, component: "nav", "aria-labelledby": "nested-list-subheader" }, navListItems &&
                        navListItems.map((item, i) => {
                            return React.createElement(ListItems, { key: i, itemData: item, isDrawerOpen: open, setActive: setActive });
                        }))),
                open && (React.createElement(Box, { sx: { position: "fixed", bottom: "5px", left: "43px", bgcolor: "background.paper", textAlign: "center" } },
                    React.createElement("img", { src: getHeaderLogo(), alt: "Login", style: { width: 35, marginLeft: 5 }, onClick: toggleDrawer })))))));
};
export default Header;
